export enum LimitsExpiry {
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
  Year = 'Year',
}
